import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button } from 'reactstrap'
import { message } from 'antd'
import styled from 'styled-components'

import MetricTemplateForm from './MetricTemplateForm'
import { storeMetricTemplate } from '../services'
import { handleError } from '../../../helpers'

export default function NewMetricTemplateForm({ metricListId, reload }) {
	const { register, handleSubmit, formState: { errors }, reset } = useForm()
	
	const onSubmit = values => {
		values.metric_list_id = metricListId
		storeMetricTemplate(values)
			.then(()=>{
				message.success('Métrica creada exitosamente')
				reset()
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<Container>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<MetricTemplateForm register={register} errors={errors} />
				<Button type="submit" color="primary">Agregar Métrica</Button>
			</Form>
		</Container>
	)
}

const Container = styled.div`
	background-color: #f8f8f8;
	padding: 20px;	
	max-width: 500px;
	margin: 20px auto 0px;
`